export const BUSINESS_TYPES = ["pharmacy", "doctors_office", "clinic", "veterinary", "medspa", "dental", "surgery_center"] as const;
export type BusinessType = typeof BUSINESS_TYPES[number];
export const BUSINESS_TYPE_LABELS: Record<BusinessType, string> = {
  pharmacy: "Pharmacy",
  doctors_office: "Doctor's Office / Medical Practice",
  clinic: "Clinic",
  veterinary: "Veterinary Practice",
  medspa: "Medical Spa / Aesthetics",
  dental: "Dental / Oral Surgery",
  surgery_center: "Ambulatory Surgery Center",
};

/** Preserve detailed website segmentation while using the ERP's existing categories. */
export function netSuiteBusinessCategory(type: string): string | null {
  switch (type) {
    case "pharmacy": return "Pharmacy";
    case "doctors_office": return "Doctor's Office";
    case "dental": return "Dentist";
    case "medspa": return "Aesthetics";
    case "surgery_center": return "Surgical Center";
    case "clinic": return "Clinic";
    case "veterinary": return "Veterinary";
    default: return null;
  }
}
